import {startHomePlanet} from './home-planet.js';
import {showAdmin} from './home-admin.js';
import './home.css';
import {api, type User} from './api.js';
const form=document.querySelector<HTMLFormElement>('#login')!;
const connected=document.querySelector<HTMLElement>('#connected')!;
const status=document.querySelector<HTMLElement>('#status')!;
const retry=document.querySelector<HTMLButtonElement>('#retry')!;
const submit=form.querySelector<HTMLButtonElement>('button')!;
const logout=document.querySelector<HTMLButtonElement>('#logout')!;
let busy=false,gameReady=false;
function show(user:User|null){
  showAdmin(user?.role==='admin');
  form.hidden=!!user;connected.hidden=!user;retry.hidden=true;status.textContent='';
  document.querySelector('#greeting')!.textContent=user?`Bienvenue, ${user.name}.${user.role==='admin'?' · Administrateur':''}`:'';
}
function failure(error:unknown){status.textContent=error instanceof Error?error.message:'Connexion impossible. Réessaie.';}
async function refresh(){
  if(busy)return;busy=true;retry.hidden=true;
  try{
    if(!gameReady){
      const res=await fetch('/api/site');if(!res.ok)throw new Error('Serveur indisponible. Réessaie dans un instant.');
      const {gameUrl}=await res.json();const url=new URL(gameUrl);
      if(!['http:','https:'].includes(url.protocol))throw new Error('Adresse du jeu invalide.');
      document.querySelector<HTMLAnchorElement>('#play')!.href=url.href;
      for(const [id,hash] of [['signup','signup'],['forgot','forgot']]){
        const link=document.querySelector<HTMLAnchorElement>('#'+id)!;url.hash=hash!;link.href=url.href;link.hidden=false;
      }
      gameReady=true;
    }
    show((await api.me()).user);
  }catch(error){failure(error);retry.hidden=false;}finally{busy=false;}
}
form.addEventListener('submit',async event=>{
  event.preventDefault();if(busy||!gameReady)return;busy=true;submit.disabled=true;status.textContent='Connexion…';
  try{const data=new FormData(form);show((await api.login({email:String(data.get('email')).trim(),password:String(data.get('password'))})).user);form.reset();}
  catch(error){failure(error);}finally{busy=false;submit.disabled=false;}
});
logout.addEventListener('click',async()=>{
  if(busy)return;busy=true;logout.disabled=true;
  try{await api.logout();show(null);}catch(error){failure(error);}finally{busy=false;logout.disabled=false;}
});
retry.addEventListener('click',()=>void refresh());
window.addEventListener('pageshow',()=>void refresh());
document.addEventListener('visibilitychange',()=>{if(!document.hidden)void refresh();});
void refresh();

startHomePlanet();
